import { CurrencyPipe, DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { MatDivider } from "@angular/material/divider";
import { FlexDirective, LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { PaymentCardViewModel } from "@tylertech/tyler-api-types";
import { KeyValue } from "./keyValue";
import { TotalsData } from "./totalsData";

@Component({
    selector: "ap-payment-detail",
    templateUrl: "./apPaymentDetail.tmpl.html",
    styleUrls: [
        "./apPaymentDetail.component.scss"
    ],
    imports: [
        CurrencyPipe,
        DatePipe,
        FlexDirective,
        LayoutAlignDirective,
        LayoutDirective,
        MatDivider,
    ]
})
export class ApPaymentDetailComponent implements OnInit
{
    private readonly paymentsByVendor = new Map<string, Array<PaymentCardViewModel>>();

    private readonly totalsMap = new Map<string, KeyValue<TotalsData>>();

    private readonly vendorsByBank = new Map<string, Set<string>>();

    @Input()
    detail: PaymentCardViewModel[];

    grandTotal: number = 0;

    hasTotalPayments: boolean;

    get count(): number
    {
        return this.detail.length;
    }

    ngOnInit(): void
    {
        this.detail.forEach(element =>
        {
            if (!this.vendorsByBank.has(element.BankCode))
            {
                this.vendorsByBank.set(element.BankCode, new Set<string>());
            }
            this.vendorsByBank.get(element.BankCode)
                .add(element.Vendor);
            if (!this.paymentsByVendor.has(element.Vendor))
            {
                this.paymentsByVendor.set(element.Vendor, []);
            }
            this.paymentsByVendor.get(element.Vendor)
                .push(element);
            if (!element.PaymentType)
            {
                return;
            }
            this.hasTotalPayments = this.hasTotalPayments || true;
            if (!this.totalsMap.has(element.PaymentType))
            {
                this.totalsMap.set(element.PaymentType, {
                    key: element.PaymentType,
                    value: {
                        count: 0,
                        amount: 0,
                    },
                });
            }
            const totals = this.totalsMap.get(element.PaymentType).value;
            totals.count++;
            totals.amount += element.TotalPayment;
            this.grandTotal += element.TotalPayment;
        });
    }

    get banks(): Array<string>
    {
        return Array.from(this.vendorsByBank.keys());
    }

    getPayments(vendorName: string): Array<PaymentCardViewModel>
    {
        return this.paymentsByVendor.get(vendorName);
    }

    get totals(): Array<KeyValue<TotalsData>>
    {
        return Array.from(this.totalsMap.values());
    }

    getVendors(bankName: string): Array<string>
    {
        return Array.from(this.vendorsByBank.get(bankName));
    }

    hasPayments(payments: PaymentCardViewModel[]): boolean
    {
        for (const payment of payments)
        {
            if (payment.PaymentType)
            {
                return true;
            }
        }
        return false;
    }
}
